/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface LazyCatalog {
  id: number;
  header: string;
  level: number;
  lastLevel: boolean;
  isLoading: boolean;
  productCount: number;
  productCountAdditional: number;
  parentId?: number;
  icon?: string;
  syncUid?: string;
  lft?: number;
  rgt?: number;
  pos?: number;
  picture?: string;
  disabled?: boolean;
  expanded?: boolean;
  children?: this[];
  enabled?: boolean;
  deleted?: boolean;
}
